module.exports = "/_next/static/images/fee_visualization_desktop-ff03a79db39da964654d674c04feb178.jpg";